import React from 'react'

export default function FooterButton({ value, color, handle }) {
    return (
        <>
            <button id={value} className='footer-button' style={{ backgroundColor: color }} onClick={() => handle(value)}>{value.replace("-", " ")}</button>
        </>
    )
}
